<app-sidebar></app-sidebar>
<app-header></app-header>
<div class="content-wrapper">
    <ngx-spinner type="ball-clip-rotate-multiple" [fullScreen]="true">
        <p style="color: white"> Loading... </p>
    </ngx-spinner>
    <div class="card text-center">
        <div class="col-md-12 no-print sticky">
            <div class="card">
                <div class="row justify-content-md-center" style="margin-top: 25px;">
                    <div class="col-md-auto">
                        <h2>รายงาน KPI เขตส่งเสริม</h2>
                    </div>
                    <div class="col-md-auto">
                        <mat-form-field appearance="fill">
                            <mat-label>เลือกงวด</mat-label>
                            <mat-select disableRipple required [(ngModel)]="selectP" (ngModelChange)="Loaddata1()">
                                <mat-option *ngFor="let item of selecttime1" [value]="item">
                                    {{item[0]}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <!--<div class="example-button-row" *ngIf="selectP.length > 0">
                            <button mat-raised-button color="primary" (click)="Loaddata1()">ตกลง</button>
                        </div>-->
                    </div>
                    <div class="col-md-auto" *ngIf="selectsup.length > 0 && dataApi0.length > 0">
                        <mat-form-field appearance="fill">
                            <mat-label>เลือกเขต/ส่วน</mat-label>
                            <mat-select disableRipple required [(ngModel)]="selectS" (ngModelChange)="filter_data()">
                                <mat-option *ngFor="let item of selectsup" [value]="item">
                                    {{item[3]}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-md-auto" *ngIf="dataApi1.length > 0">
                        <div class="button-row">
                            <span class="badge bg-warning">{{ dataApi1.length }}</span> รายการ
                            &nbsp; &nbsp;
                            <button mat-raised-button
                                *ngIf="edit_st == 0 && (userdata.userlevel == 14 || userdata.userlevel == 15)"
                                (click)="edit_st = 1">
                                <mat-icon style="color: blue;">edit</mat-icon>
                            </button>
                            <button mat-raised-button *ngIf="edit_st != 0" (click)="saveDataKpi();">
                                <mat-icon style="color: green;"> done </mat-icon>บันทึก
                            </button>
                            <button mat-raised-button *ngIf="edit_st != 0" (click)="edit_st = 0">
                                <mat-icon style="color: red;"> close </mat-icon>ยกเลิก
                            </button>
                        </div>
                        <!--<label> {{edit_st}} </label> *ngIf="dataApi1.length > 0 && edit_st == 0" -->
                    </div>
                    <div class="col-md-auto" *ngIf="dataApi1.length > 0">
                        <div class="button-row">
                            <button mat-raised-button color="accent" [disabled]="edit_st != 0"
                                (click)="printPage()"><mat-icon> print
                                </mat-icon></button>
                            <button mat-raised-button color="primary" [disabled]="edit_st != 0"
                                (click)="Loaddata1()"><mat-icon> update
                                </mat-icon></button>
                        </div>
                    </div>

                </div>
                <div class="text-center" *ngIf="sum_sv.length > 0">
                    <div class="btn-group mr-2" role="group" aria-label="Basic example" *ngFor="let sv of sum_sv">
                        <button type="button" class="btn btn-outline-danger btn-sm" id="S{{sv}}"
                            (click)="scrollTo(sv)">{{sv}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="card" style="page-break-inside: avoid;" *ngFor="let dt of dataApi1">
        <div class="card-body">
            <div class="text-center" id="{{dt.Supzone}}">
                <img src="../../../../assets/images/logo-bsf.png" alt="BSF LOGO" height="50px">
            </div>
            <table class="table table-sm">
                <tr>
                    <td style="width:50%;text-align:left;">
                        <label style="font-size:18px"> รายงาน KPI เขตส่งเสริม {{selectP[0]}}
                        </label>
                    </td>
                    <td rowspan="2" style="width:50%;text-align:right;">
                        <label style="font-size:16px"> วันที่อัพเดตข้อมูล
                            {{THtoLocalstring(dt.DateEdit)+'น.'}} </label>
                    </td>
                </tr>
                <tr>
                    <td style="text-align:left;">
                        <label style="font-size:16px">[ ส่วน: {{dt.Partcode}},
                            เขต: {{dt.Supzone}}-{{dt.ZONENAME}} ]</label>
                    </td>
                </tr>
            </table>
            <table class="table table-sm table-bordered" style="width:100%;">
                <thead style="align-content: center;">
                    <tr class="headText" style="text-shadow: 1px 1px 3px red;">
                        <td rowspan="2" colspan="2" style="width:3%"><b>No</b></td>
                        <td rowspan="2"><b> หัวข้อ KPI เขต [{{dt.Supzone}}] </b>
                        </td>
                        <td rowspan="2" colspan="2" style="width:7%"><b>เป้าหมาย</b></td>
                        <td rowspan="2" colspan="2" style="width:7%"><b>เป้างวด</b></td>
                        <td rowspan="2" colspan="2" style="width:7%"><b>ทำได้</b></td>
                        <td rowspan="2" style="width:4%"><b>%</b></td>
                        <td rowspan="2" style="width:7%"><b>ตัวถ่วง1</b></td>
                        <td rowspan="2" style="width:7%"><b>คะแนน1</b></td>
                        <td rowspan="2" style="width:7%"><b>ตัวถ่วง2</b></td>
                    </tr>
                </thead>
                <tbody style="align-content: center;" [ngSwitch]="edit_st">
                    <tr class="table-success" style="text-align:center">
                        <td colspan="2"><b>1.</b></td>
                        <td colspan="11" style="text-align:left"><b>A area (พื้นที่) ไร่</b></td>
                    </tr>
                    <tr style="text-align:center">
                        <td colspan="2"></td>
                        <td colspan="10" style="text-align:left"><u>บริหารปริมาณอ้อยตามเป้าหมาย รวมเขต</u></td>
                        <td rowspan="10">{{dt.Barrier21 | number:'1.0-1'}}</td>
                    </tr>
                    <tr style="text-align:center">
                        <td class="row_num" colspan="2"><u></u></td>
                        <td style="text-align:left">-ปริมาณตันรวมเขต</td>
                        <td colspan="2">
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #adffb1;" min="0" [(ngModel)]="dt.sTarget01"
                                (ngModelChange)="dt.modify = true;" />
                            <div *ngSwitchCase="0">{{dt.sTarget01 | number:'1.0-1' }}</div>
                        </td>
                        <td colspan="2">
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #fffcad;" min="0" [(ngModel)]="dt.Target1"
                                (ngModelChange)="dt.modify = true;" />
                            <div *ngSwitchCase="0">{{dt.Target1 | number:'1.0-1' }}</div>
                        </td>
                        <td colspan="2">{{dt.Success1 | number:'1.0-1'}}</td>
                        <td>{{(dt.Success1/dt.Target1)*100 | number:'1.0-1'}}</td>
                        <td>{{dt.Barrier11 | number:'1.0-1'}}</td>
                        <td>{{dt.score1 | number:'1.0-1'}}</td>

                    </tr>
                    <tr style="text-align:center">
                        <td class="row_num" colspan="2"><u></u></td>
                        <td style="text-align:left">-ปริมาณตันพื้นที่ดูแล</td>
                        <td colspan="2">
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #adffb1;" min="0" [(ngModel)]="dt.sTarget02"
                                (ngModelChange)="dt.modify = true;" />
                            <div *ngSwitchCase="0">{{dt.sTarget02 | number:'1.0-1' }}</div>
                        </td>
                        <td colspan="2">
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #fffcad;" min="0" [(ngModel)]="dt.Target2"
                                (ngModelChange)="dt.modify = true;" />
                            <div *ngSwitchCase="0">{{dt.Target2 | number:'1.0-1'}}</div>
                        </td>
                        <td colspan="2">
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #adceff;" min="0" [(ngModel)]="dt.Success2"
                                (ngModelChange)="dt.modify = true;" />
                            <div *ngSwitchCase="0">{{dt.Success2 | number:'1.0-1'}}</div>
                        </td>
                        <td>{{(dt.Success2/dt.Target2)*100 | number:'1.0-1'}}</td>
                        <td>{{dt.Barrier12 | number:'1.0-1'}}</td>
                        <td>{{dt.score2 | number:'1.0-1'}}</td>
                    </tr>

                    <tr style="text-align:center">
                        <td class="row_num" colspan="2"><u></u></td>
                        <td style="text-align:left">-ปริมาณตันชาวไร่ปรับโครงสร้าง</td>
                        <td colspan="2">
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #adffb1;" min="0" [(ngModel)]="dt.sTarget03"
                                (ngModelChange)="dt.modify = true;" />
                            <div *ngSwitchCase="0">{{dt.sTarget03 | number:'1.0-1' }}</div>
                        </td>
                        <td colspan="2"><input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #fffcad;" min="0" [(ngModel)]="dt.Target3"
                                (ngModelChange)="dt.modify = true;" />
                            <div *ngSwitchCase="0">{{dt.Target3 | number:'1.0-1'}}</div>
                        </td>
                        <td colspan="2">
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #adceff;" min="0" [(ngModel)]="dt.Success3"
                                (ngModelChange)="dt.modify = true;" />
                            <div *ngSwitchCase="0">{{dt.Success3 | number:'1.0-1'}}</div>
                        </td>
                        <td>{{(dt.Success3/dt.Target3)*100 | number:'1.0-1'}}</td>
                        <td>{{dt.Barrier13 | number:'1.0-1'}}</td>
                        <td>{{dt.score3 | number:'1.0-1'}}</td>
                    </tr>
                    <tr style="text-align:center">
                        <td colspan="2"></td>
                        <td colspan="10" style="text-align:left"><u>บริหารผลผลิตอ้อยตามเป้าหมาย รวมเขต</u></td>
                    </tr>

                    <tr style="text-align:center">
                        <td class="row_num" colspan="2"><u></u></td>
                        <td style="text-align:left"> อ้อยปลายฝน</td>
                        <td colspan="2">
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #adffb1;" min="0" [(ngModel)]="dt.sTarget05"
                                (ngModelChange)="dt.modify = true;" />
                            <div *ngSwitchCase="0">{{dt.sTarget05 | number:'1.0-1' }}</div>
                        </td>
                        <td colspan="2"><input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #fffcad;" min="0" [(ngModel)]="dt.Target5"
                                (ngModelChange)="dt.modify = true;" />
                            <div *ngSwitchCase="0">{{dt.Target5 | number:'1.0-1'}}</div>
                        </td>
                        <td colspan="2">{{dt.Success5 | number:'1.0-1'}}</td>
                        <td>{{(dt.Success5/dt.Target5)*100 | number:'1.0-1'}} </td>
                        <td>{{dt.Barrier15 | number:'1.0-1'}}</td>
                        <td>{{dt.score5 | number:'1.0-1'}}</td>
                    </tr>
                    <tr style="text-align:center">
                        <td class="row_num" colspan="2"><u></u></td>
                        <td style="text-align:left"> อ้อยตอ</td>
                        <td colspan="2">
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #adffb1;" min="0" [(ngModel)]="dt.sTarget06"
                                (ngModelChange)="dt.modify = true;" />
                            <div *ngSwitchCase="0">{{dt.sTarget06 | number:'1.0-1' }}</div>
                        </td>
                        <td colspan="2"><input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #fffcad;" min="0" [(ngModel)]="dt.Target6"
                                (ngModelChange)="dt.modify = true;" />
                            <div *ngSwitchCase="0">{{dt.Target6 | number:'1.0-1'}}</div>
                        </td>
                        <td colspan="2">{{dt.Success6 | number:'1.0-1'}}</td>
                        <td>{{(dt.Success6/dt.Target6)*100 | number:'1.0-1'}}</td>
                        <td>{{dt.Barrier16 | number:'1.0-1'}}</td>
                        <td>{{dt.score6 | number:'1.0-1'}}</td>
                    </tr>
                    <tr style="text-align:center">
                        <td class="row_num" colspan="2"><u></u></td>
                        <td style="text-align:left">-พื้นที่รวมเขต</td>
                        <td colspan="2">
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #adffb1;" min="0" [(ngModel)]="dt.sTarget07"
                                (ngModelChange)="dt.modify = true;" />
                            <div *ngSwitchCase="0">{{dt.sTarget07 | number:'1.0-1' }}</div>
                        </td>
                        <td colspan="2"><input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #fffcad;" min="0" [(ngModel)]="dt.Target7"
                                (ngModelChange)="dt.modify = true;" />
                            <div *ngSwitchCase="0">{{dt.Target7 | number:'1.0-1'}}</div>
                        </td>
                        <td colspan="2">{{dt.Success7 | number:'1.0-1'}}</td>
                        <td>{{(dt.Success7/dt.Target7)*100 | number:'1.0-1'}}</td>
                        <td>{{dt.Barrier17 | number:'1.0-1'}}</td>
                        <td>{{dt.score7 | number:'1.0-1'}}</td>
                    </tr>
                    <tr style="text-align:center">
                        <td class="row_num" colspan="2"><u></u></td>
                        <td style="text-align:left">-พื้นที่ดูแล</td>
                        <td colspan="2">
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #adffb1;" min="0" [(ngModel)]="dt.sTarget08"
                                (ngModelChange)="dt.modify = true;" />
                            <div *ngSwitchCase="0">{{dt.sTarget08 | number:'1.0-1' }}</div>
                        </td>
                        <td colspan="2"><input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #fffcad;" min="0" [(ngModel)]="dt.Target8"
                                (ngModelChange)="dt.modify = true;" />
                            <div *ngSwitchCase="0">{{dt.Target8 | number:'1.0-1'}}</div>
                        </td>
                        <td colspan="2">
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #adceff;" min="0" [(ngModel)]="dt.Success8"
                                (ngModelChange)="dt.modify = true;" />
                            <div *ngSwitchCase="0">{{dt.Success8 | number:'1.0-1'}}</div>
                        </td>
                        <td>{{(dt.Success8/dt.Target8)*100 | number:'1.0-1'}}</td>
                        <td>{{dt.Barrier18 | number:'1.0-1'}}</td>
                        <td>{{dt.score8 | number:'1.0-1'}}</td>
                    </tr>
                    <tr style="text-align:center">
                        <td class="row_num" colspan="2"><u></u></td>
                        <td style="text-align:left">-ชาวไร่ปรับโครงสร้าง</td>
                        <td colspan="2">
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #adffb1;" min="0" [(ngModel)]="dt.sTarget09"
                                (ngModelChange)="dt.modify = true;" />
                            <div *ngSwitchCase="0">{{dt.sTarget09 | number:'1.0-1' }}</div>
                        </td>
                        <td colspan="2">
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #fffcad;" min="0" [(ngModel)]="dt.Target9"
                                (ngModelChange)="dt.modify = true;" />
                            <div *ngSwitchCase="0">{{dt.Target9 | number:'1.0-1'}}</div>
                        </td>
                        <td colspan="2">
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #adceff;" min="0" [(ngModel)]="dt.Success9"
                                (ngModelChange)="dt.modify = true;" />
                            <div *ngSwitchCase="0">{{dt.Success9 | number:'1.0-1'}}</div>
                        <td>{{(dt.Success9/dt.Target9)*100 | number:'1.0-1'}}</td>
                        <td>{{dt.Barrier19 | number:'1.0-1'}}</td>
                        <td>{{dt.score9 | number:'1.0-1'}}</td>
                    </tr>


                    <tr class="table-secondary" style="text-align:center">
                        <td class="bg-light"></td>
                        <td colspan="2"><b>รวมข้อ 1</b></td>
                        <td colspan="2"></td>
                        <td colspan="2"></td>
                        <td colspan="2"></td>
                        <td></td>
                        <td><b>{{dt.sumbarrier1 | number:'1.0-1'}}</b></td>
                        <td><b>{{dt.scoresum1 | number:'1.0-1'}}</b></td>
                        <td><b>{{dt.score1get | number:'1.0-1'}}</b></td>
                    </tr>

                    <tr class="table-success" style="text-align:center">
                        <td colspan="2"><b>2.</b></td>
                        <td style="text-align:left"><b>B BRR MODEL (7ข้อ)</b></td>
                        <td>ER</td>
                        <td>ST</td>
                        <td>ER</td>
                        <td>ST</td>
                        <td>ER</td>
                        <td>ST</td>
                        <td colspan="8"></td>
                    </tr>
                    <tr style="text-align:center">
                        <td class="row_num" colspan="2"><u></u></td>
                        <td style="text-align:left">1. ปรับพื้นที่เพื่อระบายน้ำ <br>
                            <i class="sub_p">จัดการพื้นที่ให้ราบเรียบสามารถระบายน้ำได้ดีทำให้อ้อยเจริญเติบโตสม่ำเสมอทั่วทั้งแปลง
                                ไม่ให้เกิดพื้นที่สูญเสีย</i>
                        </td>
                        <td>
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #adffb1;" min="0" [(ngModel)]="dt.sTarget12"
                                (ngModelChange)="dt.modify = true;" />
                            <div *ngSwitchCase="0">{{dt.sTarget12 | number:'1.0-1' }}</div>
                        </td>
                        <td>
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #adffb1;" min="0" [(ngModel)]="dt.sTarget13"
                                (ngModelChange)="dt.modify = true;" />
                            <div *ngSwitchCase="0">{{dt.sTarget13 | number:'1.0-1' }}</div>
                        </td>
                        <td>
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #fffcad;" min="0" [(ngModel)]="dt.Target12"
                                (ngModelChange)="dt.modify = true;" />
                            <div *ngSwitchCase="0">{{dt.Target12 | number:'1.0-1'}}</div>
                        </td>
                        <td>
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #fffcad;" min="0" [(ngModel)]="dt.Target13"
                                (ngModelChange)="dt.modify = true;" />
                            <div *ngSwitchCase="0">{{dt.Target13 | number:'1.0-1'}}</div>
                        </td>
                        <td>
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #adceff;" min="0" [(ngModel)]="dt.Success12"
                                (ngModelChange)="dt.modify = true;" />
                            <div *ngSwitchCase="0">{{dt.Success12 | number:'1.0-1'}}</div>
                        </td>
                        <td>
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #adceff;" min="0" [(ngModel)]="dt.Success13"
                                (ngModelChange)="dt.modify = true;" />
                            <div *ngSwitchCase="0">{{dt.Success13 | number:'1.0-1'}}</div>
                        </td>
                        <td>{{((dt.Success12+dt.Success13)/(dt.Target12+dt.Target13))*100 | number:'1.0-1'}}
                        </td>
                        <td>{{dt.Barrier112 | number:'1.0-1'}}</td>
                        <td>{{dt.score12 | number:'1.0-1'}}</td>
                        <td rowspan="7">{{dt.Barrier22 | number:'1.0-1'}}</td>
                    </tr>

                    <tr style="text-align:center">
                        <td class="row_num" colspan="2"><u></u></td>
                        <td style="text-align:left">2. ระเบิดดินดาน <br>
                            <i class="sub_p">1.เพิ่มอากาศ 2.เก็บน้ำในชั้นดิน ที่ระดับชั้นดินดานลึก >40
                                เซนติเมตร</i>
                        </td>
                        <td>
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #adffb1;" min="0" [(ngModel)]="dt.sTarget14"
                                (ngModelChange)="dt.modify = true;" />
                            <div *ngSwitchCase="0">{{dt.sTarget14 | number:'1.0-1' }}</div>
                        </td>
                        <td>
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #adffb1;" min="0" [(ngModel)]="dt.sTarget15"
                                (ngModelChange)="dt.modify = true;" />
                            <div *ngSwitchCase="0">{{dt.sTarget15 | number:'1.0-1' }}</div>
                        </td>
                        <td>
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #fffcad;" min="0" [(ngModel)]="dt.Target14"
                                (ngModelChange)="dt.modify = true;" />
                            <div *ngSwitchCase="0">{{dt.Target14 | number:'1.0-1'}}</div>
                        </td>
                        <td>
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #fffcad;" min="0" [(ngModel)]="dt.Target15"
                                (ngModelChange)="dt.modify = true;" />
                            <div *ngSwitchCase="0">{{dt.Target15 | number:'1.0-1'}}</div>
                        </td>
                        <td>
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #adceff;" min="0" [(ngModel)]="dt.Success14"
                                (ngModelChange)="dt.modify = true;" />
                            <div *ngSwitchCase="0">{{dt.Success14 | number:'1.0-1'}}</div>
                            <!--<div>{{dt.Success14 | number:'1.0-1'}}</div>-->
                        </td>
                        <td>
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #adceff;" min="0" [(ngModel)]="dt.Success15"
                                (ngModelChange)="dt.modify = true;" />
                            <div *ngSwitchCase="0">{{dt.Success15 | number:'1.0-1'}}</div>
                            <!--<div>{{dt.Success15 | number:'1.0-1'}}</div>-->
                        </td>
                        <td>{{((dt.Success14+dt.Success15)/(dt.Target14+dt.Target15))*100 | number:'1.0-1'}}
                        </td>
                        <td>{{dt.Barrier114 | number:'1.0-1'}}</td>
                        <td>{{dt.score14 | number:'1.0-1'}}</td>
                    </tr>
                    <tr style="text-align:center">
                        <td class="row_num" colspan="2"><u></u></td>
                        <td style="text-align:left">3. ปลูกระยะร่อง 1.60 เมตร <br>
                            <i class="sub_p">ทำให้ใบอ้อยได้รับแสงแดดทุกใบสังเคราะห์แสงได้ดี
                                ลมอากาศถ่ายเทได้ดี</i>
                        </td>
                        <td>
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #adffb1;" min="0" [(ngModel)]="dt.sTarget16"
                                (ngModelChange)="dt.modify = true;" />
                            <div *ngSwitchCase="0">{{dt.sTarget16 | number:'1.0-1' }}</div>
                        </td>
                        <td>
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #adffb1;" min="0" [(ngModel)]="dt.sTarget17"
                                (ngModelChange)="dt.modify = true;" />
                            <div *ngSwitchCase="0">{{dt.sTarget17 | number:'1.0-1' }}</div>
                        </td>
                        <td>
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #fffcad;" min="0" [(ngModel)]="dt.Target16"
                                (ngModelChange)="dt.modify = true;" />
                            <div *ngSwitchCase="0">{{dt.Target16 | number:'1.0-1'}}</div>
                        </td>
                        <td>
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #fffcad;" min="0" [(ngModel)]="dt.Target17"
                                (ngModelChange)="dt.modify = true;" />
                            <div *ngSwitchCase="0">{{dt.Target17 | number:'1.0-1'}}</div>
                        </td>
                        <td>
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #adceff;" min="0" [(ngModel)]="dt.Success16"
                                (ngModelChange)="dt.modify = true;" />
                            <div *ngSwitchCase="0">{{dt.Success16 | number:'1.0-1'}}</div>
                        </td>
                        <td>
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #adceff;" min="0" [(ngModel)]="dt.Success17"
                                (ngModelChange)="dt.modify = true;" />
                            <div *ngSwitchCase="0">{{dt.Success17 | number:'1.0-1'}}</div>
                        </td>
                        <td>{{((dt.Success16+dt.Success17)/(dt.Target16+dt.Target17))*100 | number:'1.0-1'}}
                        </td>
                        <td>{{dt.Barrier116 | number:'1.0-1'}}</td>
                        <td>{{dt.score16 | number:'1.0-1'}}</td>
                    </tr>
                    <tr style="text-align:center">
                        <td class="row_num" colspan="2"><u></u></td>
                        <td style="text-align:left">4. อิทธิพลการใช้พันธุ์อ้อยแปลงพันธุ์สะอาด <br>
                            <i class="sub_p">ทำให้ผลผลิตอ้อยสูง ลดการเกิดโรคที่มาจากท่อนพันธุ์ %การงอกดี</i>
                        </td>
                        <td>
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #adffb1;" min="0" [(ngModel)]="dt.sTarget18"
                                (ngModelChange)="dt.modify = true;" />
                            <div *ngSwitchCase="0">{{dt.sTarget18 | number:'1.0-1' }}</div>
                        </td>
                        <td>
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #adffb1;" min="0" [(ngModel)]="dt.sTarget19"
                                (ngModelChange)="dt.modify = true;" />
                            <div *ngSwitchCase="0">{{dt.sTarget19 | number:'1.0-1' }}</div>
                        </td>
                        <td>
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #fffcad;" min="0" [(ngModel)]="dt.Target18"
                                (ngModelChange)="dt.modify = true;" />
                            <div *ngSwitchCase="0">{{dt.Target18 | number:'1.0-1'}}</div>
                        </td>
                        <td>
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #fffcad;" min="0" [(ngModel)]="dt.Target19"
                                (ngModelChange)="dt.modify = true;" />
                            <div *ngSwitchCase="0">{{dt.Target19 | number:'1.0-1'}}</div>
                        </td>
                        <td>
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #adceff;" min="0" [(ngModel)]="dt.Success18"
                                (ngModelChange)="dt.modify = true;" />
                            <div *ngSwitchCase="0">{{dt.Success18 | number:'1.0-1'}}</div>
                            <!--<div>{{dt.Success18 | number:'1.0-1'}}</div>-->
                        </td>
                        <td>
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #adceff;" min="0" [(ngModel)]="dt.Success19"
                                (ngModelChange)="dt.modify = true;" />
                            <div *ngSwitchCase="0">{{dt.Success19 | number:'1.0-1'}}</div>
                            <!--<div>{{dt.Success19 | number:'1.0-1'}}</div>-->
                        </td>
                        <td>{{((dt.Success18+dt.Success19)/(dt.Target18+dt.Target19))*100 | number:'1.0-1'}}
                        </td>
                        <td>{{dt.Barrier118 | number:'1.0-1'}}</td>
                        <td>{{dt.score18 | number:'1.0-1'}}</td>
                    </tr>
                    <tr style="text-align:center">
                        <td class="row_num" colspan="2"><u></u></td>
                        <td style="text-align:left">5. ใส่โดโลไมท์ <br>
                            <i class="sub_p">เพิ่มธาตุแคลเซียมทำให้อ้อยแข็งแรงเจริญเติบโตได้ดี
                                ธาตุแมกนีเซียมเพิ่มกระบวนการสังเคราะห์แสง ช่วยเพิ่มผลผลิต</i>
                        </td>
                        <td>
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #adffb1;" min="0" [(ngModel)]="dt.sTarget20"
                                (ngModelChange)="dt.modify = true;" />
                            <div *ngSwitchCase="0">{{dt.sTarget20 | number:'1.0-1' }}</div>
                        </td>
                        <td>
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #adffb1;" min="0" [(ngModel)]="dt.sTarget21"
                                (ngModelChange)="dt.modify = true;" />
                            <div *ngSwitchCase="0">{{dt.sTarget21 | number:'1.0-1' }}</div>
                        </td>
                        <td>
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #fffcad;" min="0" [(ngModel)]="dt.Target20"
                                (ngModelChange)="dt.modify = true;" />
                            <div *ngSwitchCase="0">{{dt.Target20 | number:'1.0-1'}}</div>
                        </td>
                        <td>
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #fffcad;" min="0" [(ngModel)]="dt.Target21"
                                (ngModelChange)="dt.modify = true;" />
                            <div *ngSwitchCase="0">{{dt.Target21 | number:'1.0-1'}}</div>
                        </td>
                        <td>
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #adceff;" min="0" [(ngModel)]="dt.Success20"
                                (ngModelChange)="dt.modify = true;" />
                            <div *ngSwitchCase="0">{{dt.Success20 | number:'1.0-1'}}</div>
                        </td>
                        <td>
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #adceff;" min="0" [(ngModel)]="dt.Success21"
                                (ngModelChange)="dt.modify = true;" />
                            <div *ngSwitchCase="0">{{dt.Success21 | number:'1.0-1'}}</div>
                        </td>
                        <td>{{((dt.Success20+dt.Success21)/(dt.Target20+dt.Target21))*100 | number:'1.0-1'}}
                        </td>
                        <td>{{dt.Barrier120 | number:'1.0-1'}}</td>
                        <td>{{dt.score20 | number:'1.0-1'}}</td>
                    </tr>
                    <tr style="text-align:center">
                        <td class="row_num" colspan="2"><u></u></td>
                        <td style="text-align:left">6. ใส่ปุ๋ยอินทรีย์ <br>
                            <i class="sub_p">ทำให้ดินมีชีวิต เพิ่มจุลินทรีย์ที่เป็นประโยชน์ในดิน
                                เพิ่มประสิทธิภาพการใช้ปุ๋ยเคมี</i>
                        </td>
                        <td>
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #adffb1;" min="0" [(ngModel)]="dt.sTarget22"
                                (ngModelChange)="dt.modify = true;" />
                            <div *ngSwitchCase="0">{{dt.sTarget22 | number:'1.0-1' }}</div>
                        </td>
                        <td>
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #adffb1;" min="0" [(ngModel)]="dt.sTarget23"
                                (ngModelChange)="dt.modify = true;" />
                            <div *ngSwitchCase="0">{{dt.sTarget23 | number:'1.0-1' }}</div>
                        </td>
                        <td>
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #fffcad;" min="0" [(ngModel)]="dt.Target22"
                                (ngModelChange)="dt.modify = true;" />
                            <div *ngSwitchCase="0">{{dt.Target22 | number:'1.0-1'}}</div>
                        </td>
                        <td>
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #fffcad;" min="0" [(ngModel)]="dt.Target23"
                                (ngModelChange)="dt.modify = true;" />
                            <div *ngSwitchCase="0">{{dt.Target23 | number:'1.0-1'}}</div>
                        </td>
                        <td>
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #adceff;" min="0" [(ngModel)]="dt.Success22"
                                (ngModelChange)="dt.modify = true;" />
                            <div *ngSwitchCase="0">{{dt.Success22 | number:'1.0-1'}}</div>
                        </td>
                        <td>
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #adceff;" min="0" [(ngModel)]="dt.Success23"
                                (ngModelChange)="dt.modify = true;" />
                            <div *ngSwitchCase="0">{{dt.Success23 | number:'1.0-1'}}</div>
                        </td>
                        <td>{{((dt.Success22+dt.Success23)/(dt.Target22+dt.Target23))*100 | number:'1.0-1'}}
                        </td>
                        <td>{{dt.Barrier122 | number:'1.0-1'}}</td>
                        <td>{{dt.score22 | number:'1.0-1'}}</td>
                    </tr>
                    <tr style="text-align:center">
                        <td class="row_num" colspan="2"><u></u></td>
                        <td style="text-align:left">7. ใส่ปุ๋ยเคมี <br>
                            <i class="sub_p">ให้ปุ๋ยตรงสูตร ตรงเวลา ปริมาณเพียงพอ ต่อความต้องการของอ้อย</i>
                        </td>
                        <td>
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #adffb1;" min="0" [(ngModel)]="dt.sTarget24"
                                (ngModelChange)="dt.modify = true;" />
                            <div *ngSwitchCase="0">{{dt.sTarget24 | number:'1.0-1' }}</div>
                        </td>
                        <td>
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #adffb1;" min="0" [(ngModel)]="dt.sTarget25"
                                (ngModelChange)="dt.modify = true;" />
                            <div *ngSwitchCase="0">{{dt.sTarget25 | number:'1.0-1' }}</div>
                        </td>
                        <td>
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #fffcad;" min="0" [(ngModel)]="dt.Target24"
                                (ngModelChange)="dt.modify = true;" />
                            <div *ngSwitchCase="0">{{dt.Target24 | number:'1.0-1'}}</div>
                        </td>
                        <td>
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #fffcad;" min="0" [(ngModel)]="dt.Target25"
                                (ngModelChange)="dt.modify = true;" />
                            <div *ngSwitchCase="0">{{dt.Target25 | number:'1.0-1'}}</div>
                        </td>
                        <td>
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #adceff;" min="0" [(ngModel)]="dt.Success24"
                                (ngModelChange)="dt.modify = true;" />
                            <div *ngSwitchCase="0">{{dt.Success24 | number:'1.0-1'}}</div>
                            <!--<div>{{dt.Success24 | number:'1.0-1'}}</div>-->
                        </td>
                        <td>
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #adceff;" min="0" [(ngModel)]="dt.Success25"
                                (ngModelChange)="dt.modify = true;" />
                            <div *ngSwitchCase="0">{{dt.Success25 | number:'1.0-1'}}</div>
                            <!--<div>{{dt.Success25 | number:'1.0-1'}}</div>-->
                        </td>
                        <td>{{((dt.Success24+dt.Success25)/(dt.Target24+dt.Target25))*100 | number:'1.0-1'}}
                        </td>
                        <td>{{dt.Barrier124 | number:'1.0-1'}}</td>
                        <td>{{dt.score24 | number:'1.0-1'}}</td>
                    </tr>



                    <tr class="table-secondary" style="text-align:center">
                        <td class="bg-light"></td>
                        <td colspan="2"><b>รวมข้อ 2</b></td>
                        <td colspan="2"></td>
                        <td colspan="2"></td>
                        <td colspan="2"></td>

                        <td></td>
                        <td><b>{{dt.sumbarrier2 | number:'1.0-1'}}</b></td>
                        <td><b>{{dt.scoresum2 | number:'1.0-1'}}</b></td>
                        <td><b>{{dt.score2get | number:'1.0-1'}}</b></td>
                    </tr>

                    <tr class="table-success" style="text-align:center">
                        <td colspan="2"><b>3.</b></td>
                        <td colspan="11" style="text-align:left"><b>C control (บริหารเขต)</b></td>
                    </tr>

                    <tr style="text-align:center">
                        <td class="row_num" colspan="2"><u></u></td>
                        <td style="text-align:left">1. บริหารความถูกต้องของข้อมูลเขต</td>
                        <td colspan="2">
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #adffb1;" min="0" [(ngModel)]="dt.sTarget27"
                                (ngModelChange)="dt.modify = true;" />
                            <div *ngSwitchCase="0">{{dt.sTarget27 | number:'1.0-1' }}</div>
                        </td>
                        <td colspan="2">
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #fffcad;" min="0" [(ngModel)]="dt.Target27"
                                (ngModelChange)="dt.modify = true" />
                            <div *ngSwitchCase="0">{{dt.Target27 | number:'1.0-1'}}</div>

                        </td>
                        <td colspan="2">
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #adceff;" min="0" [(ngModel)]="dt.Success27"
                                (ngModelChange)="dt.modify = true" />
                            <div *ngSwitchCase="0">{{dt.Success27 | number:'1.0-1'}}</div>
                        </td>
                        <td>{{(dt.Success27/dt.Target27)*100 | number:'1.0-1'}}
                        <td>{{dt.Barrier127 | number:'1.0-1'}}</td>
                        <td>{{dt.score27 | number:'1.0-1'}}</td>
                        <td rowspan="3">{{dt.Barrier23 | number:'1.0-1'}}</td>
                    </tr>
                    <tr style="text-align:center">
                        <td class="row_num" colspan="2"><u></u></td>
                        <td style="text-align:left">2. ตรวจสอบภายใน</td>
                        <td colspan="2">
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #adffb1;" min="0" [(ngModel)]="dt.sTarget28"
                                (ngModelChange)="dt.modify = true;" />
                            <div *ngSwitchCase="0">{{dt.sTarget28 | number:'1.0-1' }}</div>
                        </td>
                        <td colspan="2">
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #fffcad;" min="0" [(ngModel)]="dt.Target28"
                                (ngModelChange)="dt.modify = true" />
                            <div *ngSwitchCase="0">{{dt.Target28 | number:'1.0-1'}}</div>
                        </td>
                        <td colspan="2">
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #adceff;" min="0" [(ngModel)]="dt.Success28"
                                (ngModelChange)="dt.modify = true" />
                            <div *ngSwitchCase="0">{{dt.Success28 | number:'1.0-1'}}</div>
                        </td>
                        <td>{{(dt.Success28/dt.Target28)*100 | number:'1.0-1'}}
                        <td>{{dt.Barrier128 | number:'1.0-1'}}</td>
                        <td>{{dt.score28 | number:'1.0-1'}}</td>
                    </tr>
                    <tr style="text-align:center">
                        <td class="row_num" colspan="2"><u></u></td>
                        <td style="text-align:left">3. ตรวจเยี่ยมหัวหน้ากลุ่มสร้างอ้อย ในเขต<br>
                            <i class="sub_p"> กลุ่มที่มีปัญหา / กิจกรรมที่จะทำ ทำแผน ติดตามแผน
                                วิเคราะห์ปัญหา</i>
                        </td>
                        <td colspan="2">
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #adffb1;" min="0" [(ngModel)]="dt.sTarget29"
                                (ngModelChange)="dt.modify = true;" />
                            <div *ngSwitchCase="0">{{dt.sTarget29 | number:'1.0-1' }}</div>
                        </td>
                        <td colspan="2">
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #fffcad;" min="0" [(ngModel)]="dt.Target29"
                                (ngModelChange)="dt.modify = true" />
                            <div *ngSwitchCase="0">{{dt.Target29 | number:'1.0-1'}}</div>
                        </td>
                        <td colspan="2">
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #adceff;" min="0" [(ngModel)]="dt.Success29"
                                (ngModelChange)="dt.modify = true" />
                            <div *ngSwitchCase="0">{{dt.Success29| number:'1.0-1'}}</div>
                        </td>
                        <td>{{(dt.Success29/dt.Target29)*100 | number:'1.0-1'}}
                        <td>{{dt.Barrier129 | number:'1.0-1'}}</td>
                        <td>{{dt.score29 | number:'1.0-1'}}</td>
                    </tr>

                    <tr class="table-secondary" style="text-align:center">
                        <td class="bg-light"></td>
                        <td colspan="2"><b>รวมข้อ 3</b></td>
                        <td colspan="2"></td>
                        <td colspan="2"></td>
                        <td colspan="2"></td>
                        <td></td>
                        <td><b>{{dt.sumbarrier3 | number:'1.0-1'}}</b></td>
                        <td><b>{{dt.scoresum3 | number:'1.0-1'}}</b></td>
                        <td><b>{{dt.score3get | number:'1.0-1'}}</b></td>
                    </tr>

                    <tr class="table-success" style="text-align:center">
                        <td colspan="2" style="text-align:center"><b>4.</b></td>
                        <td colspan="11" style="text-align:left"><b>D develop (พัฒนา)</b></td>
                    </tr>

                    <tr style="text-align:center">
                        <td class="row_num" colspan="2"><u></u></td>
                        <td style="text-align:left">1. เป้าหมายชาวไร่ เกรด A เป็น นักส่งเสริมวิชาการของตนเอง
                        </td>
                        <td colspan="2">
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #adffb1;" min="0" [(ngModel)]="dt.sTarget31"
                                (ngModelChange)="dt.modify = true;" />
                            <div *ngSwitchCase="0">{{dt.sTarget31 | number:'1.0-1' }}</div>
                        </td>
                        <td colspan="2">
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #fffcad;" min="0" [(ngModel)]="dt.Target31"
                                (ngModelChange)="dt.modify = true" />
                            <div *ngSwitchCase="0">{{dt.Target31 | number:'1.0-1'}}</div>
                        </td>
                        <td colspan="2">
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #adceff;" min="0" [(ngModel)]="dt.Success31"
                                (ngModelChange)="dt.modify = true" />
                            <div *ngSwitchCase="0">{{dt.Success31 | number:'1.0-1'}}</div>
                        </td>
                        <td>{{(dt.Success31/dt.Target31)*100 | number:'1.0-1'}}
                        <td>{{dt.Barrier131 | number:'1.0-1'}}</td>
                        <td>{{dt.score31 | number:'1.0-1'}}</td>
                        <td rowspan="5">{{dt.Barrier24 | number:'1.0-1'}}</td>
                    </tr>
                    <tr style="text-align:center">
                        <td class="row_num" colspan="2"><u></u></td>
                        <td style="text-align:left">2. พัฒนายกระดับ เกรดชาวไร่ B, C ขึ้นเป็น A รวมเขต</td>
                        <td colspan="2">
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #adffb1;" min="0" [(ngModel)]="dt.sTarget32"
                                (ngModelChange)="dt.modify = true;" />
                            <div *ngSwitchCase="0">{{dt.sTarget32 | number:'1.0-1' }}</div>
                        </td>
                        <td colspan="2">
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #fffcad;" min="0" [(ngModel)]="dt.Target32"
                                (ngModelChange)="dt.modify = true" />
                            <div *ngSwitchCase="0">{{dt.Target32 | number:'1.0-1'}}</div>
                        </td>
                        <td colspan="2">
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #adceff;" min="0" [(ngModel)]="dt.Success32"
                                (ngModelChange)="dt.modify = true" />
                            <div *ngSwitchCase="0">{{dt.Success32 | number:'1.0-1'}}</div>
                        </td>
                        <td>{{(dt.Success32/dt.Target32)*100 | number:'1.0-1'}}
                        <td>{{dt.Barrier132 | number:'1.0-1'}}</td>
                        <td>{{dt.score32 | number:'1.0-1'}}</td>
                    </tr>
                    <tr style="text-align:center">
                        <td class="row_num" colspan="2"><u></u></td>
                        <td style="text-align:left">3. พัฒนาชาวไร่รายใหม่</td>
                        <td colspan="2">
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #adffb1;" min="0" [(ngModel)]="dt.sTarget33"
                                (ngModelChange)="dt.modify = true;" />
                            <div *ngSwitchCase="0">{{dt.sTarget33 | number:'1.0-1' }}</div>
                        </td>
                        <td colspan="2">
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #fffcad;" min="0" [(ngModel)]="dt.Target33"
                                (ngModelChange)="dt.modify = true" />
                            <div *ngSwitchCase="0">{{dt.Target33 | number:'1.0-1'}}</div>
                        </td>
                        <td colspan="2">
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #adceff;" min="0" [(ngModel)]="dt.Success33"
                                (ngModelChange)="dt.modify = true" />
                            <div *ngSwitchCase="0">{{dt.Success33 | number:'1.0-1'}}</div>
                        </td>
                        <td>{{(dt.Success33/dt.Target33)*100 | number:'1.0-1'}}
                        <td>{{dt.Barrier133 | number:'1.0-1'}}</td>
                        <td>{{dt.score33 | number:'1.0-1'}}</td>
                    </tr>
                    <tr style="text-align:center">
                        <td class="row_num" colspan="2"><u></u></td>
                        <td style="text-align:left">4. พัฒนากลุ่มชาวไร่ปรับโครงสร้าง ของเขต</td>
                        <td colspan="2">
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #adffb1;" min="0" [(ngModel)]="dt.sTarget34"
                                (ngModelChange)="dt.modify = true;" />
                            <div *ngSwitchCase="0">{{dt.sTarget34 | number:'1.0-1' }}</div>
                        </td>
                        <td colspan="2">
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #fffcad;" min="0" [(ngModel)]="dt.Target34"
                                (ngModelChange)="dt.modify = true" />
                            <div *ngSwitchCase="0">{{dt.Target34 | number:'1.0-1'}}</div>
                        </td>
                        <td colspan="2">
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #adceff;" min="0" [(ngModel)]="dt.Success34"
                                (ngModelChange)="dt.modify = true" />
                            <div *ngSwitchCase="0">{{dt.Success34 | number:'1.0-1'}}</div>
                        </td>
                        <td>{{(dt.Success34/dt.Target34)*100 | number:'1.0-1'}}
                        <td>{{dt.Barrier134 | number:'1.0-1'}}</td>
                        <td>{{dt.score34 | number:'1.0-1'}}</td>
                    </tr>
                    <tr style="text-align:center">
                        <td class="row_num" colspan="2"><u></u></td>
                        <td style="text-align:left"> ติดตามดำเนินงานให้ได้ตามสัญญา
                            ส่งสรุปผลดำเนินงานชาวไร่ปรับโครงสร้าง</td>
                        <td colspan="2">
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #adffb1;" min="0" [(ngModel)]="dt.sTarget35"
                                (ngModelChange)="dt.modify = true;" />
                            <div *ngSwitchCase="0">{{dt.sTarget35 | number:'1.0-1' }}</div>
                        </td>
                        <td colspan="2">
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #fffcad;" min="0" [(ngModel)]="dt.Target35"
                                (ngModelChange)="dt.modify = true" />
                            <div *ngSwitchCase="0">{{dt.Target35 | number:'1.0-1'}}</div>
                        </td>
                        <td colspan="2">
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #adceff;" min="0" [(ngModel)]="dt.Success35"
                                (ngModelChange)="dt.modify = true" />
                            <div *ngSwitchCase="0">{{dt.Success35 | number:'1.0-1'}}</div>
                        </td>
                        <td>{{(dt.Success35/dt.Target35)*100 | number:'1.0-1'}}
                        <td>{{dt.Barrier135 | number:'1.0-1'}}</td>
                        <td>{{dt.score35 | number:'1.0-1'}}</td>
                    </tr>

                    <tr class="table-secondary" style="text-align:center">
                        <td class="bg-light"></td>

                        <td colspan="2"><b>รวมข้อ 4</b></td>
                        <td colspan="2"></td>
                        <td colspan="2"></td>
                        <td colspan="2"></td>
                        <td></td>
                        <td><b>{{dt.sumbarrier4 | number:'1.0-1'}}</b></td>
                        <td><b>{{dt.scoresum4 | number:'1.0-1'}}</b></td>
                        <td><b>{{dt.score4get | number:'1.0-1'}}</b></td>
                    </tr>

                    <tr class="table-success" style="text-align:center">
                        <td colspan="2" style="text-align:center"><b>5.</b></td>
                        <td colspan="11" style="text-align:left"><b>T Team Work (การทำงานเป็นทีม) </b></td>
                    </tr>
                    <tr style="text-align:center">
                        <td class="row_num" colspan="2"><u></u></td>
                        <td style="text-align:left">1. ค่าคะแนนรวมเขต </td>
                        <td colspan="2">
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #adffb1;" min="0" [(ngModel)]="dt.sTarget36"
                                (ngModelChange)="dt.modify = true;" />
                            <div *ngSwitchCase="0">{{dt.sTarget36 | number:'1.0-1' }}</div>
                        </td>
                        <td colspan="2">
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #fffcad;" min="0" [(ngModel)]="dt.Target36"
                                (ngModelChange)="dt.modify = true" />
                            <div *ngSwitchCase="0">{{dt.Target36 | number:'1.0-1'}}</div>
                        </td>
                        <td colspan="2">
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #adceff;" min="0" [(ngModel)]="dt.Success36"
                                (ngModelChange)="dt.modify = true" />
                            <div *ngSwitchCase="0">{{dt.Success36 | number:'1.0-1'}}</div>
                        </td>
                        <td>{{(dt.Success36/dt.Target36)*100 | number:'1.0-1'}}
                        <td>{{dt.Barrier136 | number:'1.0-1'}}</td>
                        <td>{{dt.score36 | number:'1.0-1'}}</td>
                        <td rowspan="2">{{dt.Barrier25 | number:'1.0-1'}}</td>
                    </tr>
                    <tr style="text-align:center">
                        <td class="row_num" colspan="2"><u></u></td>
                        <td style="text-align:left">2. คะแนนผู้บริหาร </td>
                        <td colspan="2">
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #adffb1;" min="0" [(ngModel)]="dt.sTarget37"
                                (ngModelChange)="dt.modify = true;" />
                            <div *ngSwitchCase="0">{{dt.sTarget37 | number:'1.0-1' }}</div>
                        </td>
                        <td colspan="2">
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #fffcad;" min="0" [(ngModel)]="dt.Target37"
                                (ngModelChange)="dt.modify = true" />
                            <div *ngSwitchCase="0">{{dt.Target37 | number:'1.0-1'}}</div>
                        </td>
                        <td colspan="2">
                            <input *ngSwitchCase="1" type="number" matInput
                                style="text-align:center; background: #adceff;" min="0" [(ngModel)]="dt.Success37"
                                (ngModelChange)="dt.modify = true" />
                            <div *ngSwitchCase="0">{{dt.Success37 | number:'1.0-1'}}</div>
                        </td>
                        <td>{{(dt.Success37/dt.Target37)*100 | number:'1.0-1'}}
                        <td>{{dt.Barrier137 | number:'1.0-1'}}</td>
                        <td>{{dt.score37 | number:'1.0-1'}}</td>
                    </tr>

                    <tr class="table-secondary" style="text-align:center">
                        <td class="bg-light"></td>
                        <td colspan="2"><b>รวมข้อ 5</b></td>
                        <td colspan="2"></td>
                        <td colspan="2"></td>
                        <td colspan="2"></td>
                        <td></td>
                        <td><b>{{dt.sumbarrier5 | number:'1.0-1'}}</b></td>
                        <td><b>{{dt.scoresum5 | number:'1.0-1'}}</b></td>
                        <td><b>{{dt.score5get | number:'1.0-1'}}</b></td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr class="table-primary under" style="text-align:center">
                        <td>รวม</td>
                        <td colspan="2"></td>
                        <td colspan="2"></td>
                        <td colspan="2"></td>
                        <td colspan="2"></td>
                        <td></td>
                        <td></td>
                        <td>{{dt.sumBarrier20 | number:'1.0-1'}}</td>
                        <td>{{dt.scoretotal | number:'1.0-1'}}</td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
</div>
<app-footer></app-footer>